<template>
  <div class="login">
    <div>
      <ModalRegister :active="getModal == 'register'" @close="event => setModal(event)" />
      <ModalRecovery :active="getModal == 'recovery'" @close="event => setModal(event)" />
      <ModalConfirm :active="getModal == 'confirm'" @close="event => setModal(event)" />
    </div>
    <div class="center-flex" style="text-align: -webkit-center; ">
      <div v-if="isAmoGo()" >
        <div class="image">
          <img src="../../assets/images/amo-go-name.svg" />
        </div>
      <span style="font-size: 16px; font-weight: bold;color: var(--text);">
        Chama, coleta, entrega
      </span>
    </div>
      <div  v-if="!isAmoGo()"  class="flex-row wellcome">
        <div class="image">
          <img v-if="icon" :src="establishment_icon" />
          <img v-else src="../../assets/images/icon.svg" />
        </div>
        <span v-html="welcome_message_computed"></span>
      </div>
      <form>
        <div class="flex-column p-top-25">
          <label v-if="!isAmoGo()" class="label">Faça login com seu e-mail</label>
          <Input
            :value="email"
            @change="event => email = event"
            placeholder="E-mail"
            :disabled="sending"
            :invalid="$v.email.$invalid"
          />
          <Input
            :value="password"
            @change="event => password = event"
            type="password"
            placeholder="Senha"
            :disabled="sending"
            :invalid="$v.password.$invalid"
          />
          <Alert
            v-for="(alert, index) in getAlerts"
            :key="index"
            :title="alert.title"
            :icon="alert.icon"
            :type="alert.type"
          />
        </div>
        <div v-if="!isAmoGo()" class="flex-row top p-bottom-25">
          <Button :disabled="sending" :loading="sending" type="primary" title="Entrar" @click="submit()" />
          <Button @click="setModal('recovery')" type="light" title="Esqueci minha senha." />
        </div>
        <div v-if="isAmoGo()" class="flex-row top p-bottom-25" style="display: contents;">
          <div>
            <Button @click="setModal('recovery')" type="light" title="Esqueci minha senha." style="border-bottom: 1px solid; border-radius: 0px;" />
          </div>
          <div>
            <Button :disabled="sending" :loading="sending" type="primary" title="Entrar" @click="submit()" style="width: 15rem; border-radius: 20px;" />
          </div>
        </div>
      </form>
      <div v-if="!isAmoGo()"  class="flex-column">
        <label class="label light">Cadastre-se ou entre através do Facebook.</label>
        <Button @click="setModal('register')" type="primary" title="Cadastre-se" />
        <Facebook />
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, minLength } from 'vuelidate/lib/validators'
import api from '../../services/api'
import common from '../../mixins/common'

import Input from '../Input'
import Button from '../Button'
import Alert from '../Alert'
import ModalRegister from '../ModalRegister'
import ModalRecovery from '../ModalRecovery'
import ModalConfirm from '../ModalConfirm'
import Facebook from '../Facebook'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Login',
  components: {
    Input,
    Button,
    Alert,
    ModalRegister,
    ModalRecovery,
    ModalConfirm,
    Facebook
  },
  data () {
    return {
      email: '',
      password: '',
      sending: false,
      icon: null,
      establishment_icon: '',
      messages: ['Que bom que você está de <br />volta! Seja bem-vindo (a)', 'Fico feliz que você<br /> esteja por aqui!'],
      welcome_message: ''
    }
  },
  mixins: [common],
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(4) }
  },
  computed: {
    ...mapGetters(['getModal', 'getAlerts']),
    welcome_message_computed () {
      const ct = this.$route.query.client_type

      return ct && ct === 'panel' ? 'Bem vindo (a) ao<br />Painel Amo!' : this.welcome_message
    }
  },
  methods: {
    ...mapMutations(['setModal']),
    ...mapActions(['addAlert', 'clearAlert', 'xToken']),
    isAmoGo() {
      const client_type = this.clientType;
      if(!client_type){
        return false;
      }
      if (client_type === "amogo") {
        return true;
      }
      return false;
    },
    async submit () {
      this.clearAlert()
      if (this.sending) {
        return
      }
      this.sending = true
      if (this.$v.$invalid) {
        this.addAlert({
          type: 'danger',
          icon: 'alert-rhombus-outline',
          title: 'Por favor, verifique seus dados.'
        })
        this.sending = false
        return
      }
      try {
        const params = {}

        if (this.clientType) {
          params.client_type = this.clientType
        }
        if (this.establishmentId) {
          params.establishment_id = this.establishmentId
        }
        params.email = this.email
        params.password = this.password

        const response = await api.post('/users/login', params)
        if (response.data.token) {
          this.addAlert({
            type: 'success',
            icon: 'checkbox-marked-circle-outline',
            title: 'Bem vindo! Estamos redirecionando para sua página!'
          })
          this.redirect(response.data.token)
        } else {
          this.sending = false
        }
      } catch (error) {
        this.addAlert({
          type: 'danger',
          icon: 'alert-rhombus-outline',
          title: 'Por favor, verifique seus dados.'
        })
        this.sending = false
      }
    },
    async loadEstablishment (to) {
      this.xToken()
      this.welcome_message = this.messages[Math.round(Math.random())]
      const establishmentId = to?.$route?.query?.establishment_id || this.$route.query.establishment_id
      if (!establishmentId) return

      try {
        const resp = await api.get(`/establishments/${establishmentId}?fields=company&fields=design`)
        this.icon = resp.data.design.icon || resp.data.design.logo
        this.establishment_icon = `//res.cloudinary.com/amodeliveryimgs/image/upload/w_240,h_240/${this.icon}`
      } catch (error) {
        this.establishment_icon = ''
      }
    }
  },
  created () {
    this.loadEstablishment()
  },
  watch: {
    $route (to, from) {
      this.loadEstablishment(to)
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
